import { useRouter } from 'next/router';
import { css } from '@appd/uik';

interface LinkV2Props {
  href: string;
  styles?: Record<string, string | css.Styles>;
  label: string;
}

const LinkV2: React.FC<LinkV2Props> = ({ href, styles, label }): JSX.Element => {
  const router = useRouter();

  const isExternalLink = /^https?:\/\//.test(href);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (!isExternalLink) {
      e.preventDefault();
      const encodedHref = `/${router.query.appName}/${encodeURIComponent(href)}`;
      router.push(encodedHref);
    }
  };

  const finalHref = isExternalLink ? href : `/${router.query.appName}/${encodeURIComponent(href)}`;

  return (
    <a
      href={finalHref}
      onClick={handleClick}
      className={`${css(styles)} text-interact-text hover:text-interact-text-hover`}
      target={isExternalLink ? '_blank' : '_self'}
      rel={isExternalLink ? 'noopener noreferrer' : undefined}
    >
      {label}
    </a>
  );
};

export default LinkV2;
